import { formDataRequest, postRequest } from "../libs/AxiosService.util";

export async function serviceFetchEzuppBlogs(params) {
  return await postRequest("ezupp-blogs", params);
}

export async function serviceEzuppBlogDetails(params) {
  return await postRequest("ezupp-blogs/details", params);
}

export async function serviceCreateEzuppBlog(params) {
  return await postRequest("ezupp-blogs/create", params);
}

export async function serviceUpdateEzuppBlog(params) {
  return await postRequest("ezupp-blogs/update", params);
}

export async function serviceDeleteEzuppBlog(params) {
  return await postRequest("ezupp-blogs/delete", params);
}

export async function servicePublishEzuppBlog(params) {
  return await postRequest("ezupp-blogs/publish", params);
}

export async function serviceUnpublishEzuppBlog(params) {
  return await postRequest("ezupp-blogs/unpublish", params);
}

export async function serviceCheckEzuppBlogSlug(params) {
  return await postRequest("ezupp-blogs/check/slug", params);
}

/** formData must contain the file under "image". Resolves to { image: absoluteUrl, path }. */
export async function serviceUploadEzuppBlogImage(formData) {
  return await formDataRequest("ezupp-blogs/upload/image", formData);
}
